const SALVAR_USUARIO_STATE = (state, payload) => {
  state.login = payload
}

const LOGANDO = (state, payload) => {
  state.logando = payload
}

const DELETAR_USUARIO_STATE = (state) => {
  state.login = {}
}

const ATUALIZAR_ROLE_USUARIO = (state, payload) => {
  state.login = {
    ...state.login,
    role_ativo: payload
  }
}

export {
  SALVAR_USUARIO_STATE,
  DELETAR_USUARIO_STATE,
  LOGANDO,
  ATUALIZAR_ROLE_USUARIO
}